<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.expense_record_feature.expense_record') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <div class="form-group row m-b-15">
                <label class="col-md-5 col-form-label control-label required">
                  {{ $t('addministration.expense_record_feature.date') }}
                </label>
                <div class="col-md-7">
                  <ts-date-picker-input
                    ref="expense_date"
                    v-model="model.expense_date"
                  />
                  <div class="validate">
                    {{ errors.first('expense_date') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('addministration.expense_record_feature.item_name') }}
                </label>
                <div class="col-md-7">
                  <ts-search-select
                    v-model.number="model.expense_item_id"
                    :options="expenseItemOptions"
                  ></ts-search-select>
                  <router-link
                    class="text-info"
                    :to="{
                      name: 'expense-item'
                    }"
                    v-tooltip="
                      $t(
                        'addministration.expense_record_feature.add_expense_item'
                      )
                    "
                  >
                    <small>{{
                      $t(
                        'addministration.expense_record_feature.add_expense_item'
                      )
                    }}</small>
                  </router-link>
                  <div class="validate" v-if="errors.has('expense_item_id')">
                    {{ errors.first('expense_item_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{
                    $t('addministration.expense_record_feature.currency')
                  }}</label
                >
                <div class="col-md-7">
                  <div class="input-group">
                    <select
                      v-model.number="model.currency_id"
                      @change="currencyChange"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('currency_id') }"
                    >
                      <option value="" disabled selected style="display: none;">
                        --{{
                          $t('addministration.expense_record_feature.select')
                        }}--</option
                      >
                      <option
                        v-for="(currency, index) in currencies"
                        :key="index"
                        :value="currency.currency_id"
                      >
                        {{ currency.currency_name_en }} |
                        {{ currency.currency_code }}
                      </option>
                    </select>
                    <div class="input-group-addon">
                      <router-link
                        class="text-info"
                        :to="{
                          name: 'currency'
                        }"
                        v-tooltip="
                          $t(
                            'addministration.expense_record_feature.add_currency'
                          )
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('currency_id')"
                  >
                    {{ errors.first('currency_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label required">
                  {{ $t('addministration.expense_record_feature.amount') }}
                </label>
                <div class="col-md-7">
                  <div class="input-group">
                    <div v-if="sign" class="input-group-addon">
                      {{ sign }}
                    </div>
                    <input
                      v-model="model.expense_amount"
                      type="text"
                      class="form-control kh-font"
                      :class="{ 'is-invalid': errors.has('expense_amount') }"
                      ref="expense_amount"
                      :placeholder="
                        $t(
                          'addministration.expense_record_feature.enter_expense_amount'
                        )
                      "
                    />
                  </div>
                  <div class="validate" v-if="errors.has('expense_amount')">
                    {{ errors.first('expense_amount') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.expense_record_feature.description') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    :class="{ 'is-invalid': errors.has('description') }"
                    class="form-control"
                    rows="3"
                    v-model="model.description"
                    :placeholder="
                      $t(
                        'addministration.expense_record_feature.enter_description'
                      )
                    "
                  >
                  </textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('description')"
                  >
                    {{ errors.first('description') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row  text-right">
            <div class="col-lg-12">
              <ts-button
                class="ml-2"
                color="primary"
                :waiting="saving"
                @click="update"
              >
                {{ $t('addministration.expense_record_feature.update') }}
              </ts-button>

              <ts-button
                class="ml-2"
                @click="$router.push({ name: 'expense-record' })"
              >
                {{ $t('addministration.expense_record_feature.cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'expense-record-edit',
  props: ['expenseRecord'],
  data() {
    return {
      model: _.cloneDeep(this.expenseRecord),
      saving: false,
      errors: new Errors(),
      sign: ''
    }
  },
  computed: {
    ...mapState('expenseRecord', ['currencies']),
    expenseItemOptions() {
      return this.$store.state.expenseRecord.expense_items.map(el => ({
        value: el.expense_item_id,
        text:
          el.expense_item_name_en +
          (el.expense_item_name_kh !== null
            ? ' | ' + el.expense_item_name_kh
            : '')
      }))
    }
  },
  methods: {
    currencyChange() {
      this.sign = this.currencies.filter(
        c => c.currency_id == this.model.currency_id
      )[0].currency_sign
      this.$refs.expense_amount.focus()
    },
    update() {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('expenseRecord/update', Object.assign({}, this.model))
        .then(respons => {
          this.$toasted.success(respons.message)
          this.$router.push({ name: 'expense-record' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  },
  watch: {
    'model.currency_id': function(value) {
      if (value) {
        this.currencyChange()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('expenseRecord/RESET_STATE')
      this.$store.commit('expenseRecord/SET_EXPENSE_ITEMS', [])
      this.$store.commit('expenseRecord/SET_CURRENCIES', [])
    }
    next()
  }
}
</script>
